module.exports = __webpack_public_path__ + "img/relevant-notice-image.2eb5f22f.png";